<template>
  <div class="d-flex justify-content-center align-items-center">
    <form class="login-form" @submit.prevent="auth">
      <div class="card mb-0">
        <div class="card-body">
          <div class="text-center">
            <div
              class="d-inline-flex align-items-center justify-content-center"
            >
              <img src="@/assets/img/logos/logo.svg" class="h-72px" />
            </div>
            <h4 class="text-primary">NPS</h4>
          </div>
          <div class="text-center mb-2">
            <button
              type="submit"
              class="btn btn-primary"
              title="Login com Microsoft"
              :disabled="disableButton"
            >
              <i class="ph ph-squares-four me-2"></i>
              Login com Microsoft
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'SignIn',

  data() {
    return {
      disableButton: false,
    }
  },

  methods: {
    async auth() {
      try {
        this.disableButton = true

        const response = await this.$store.dispatch('getMicrosoftLink')

        if (response && response.link && response.link !== '') {
          this.disableButton = false
          window.location.href = response.link
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
          this.disableButton = false
        }
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },
}
</script>
